<template>
  <div class="flex-center login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      autocomplete="on"
      label-position="left"
    >

      <h3 class="title">登录</h3>
      <el-form-item :class="isUsernameFocus ? 'el-form-item-focus' : ''" prop="username">
        <el-input
          ref="username"
          v-model="loginForm.username"
          placeholder="请输入账号"
          name="username"
          type="text"
          tabindex="1"
          autocomplete="on"
          @focus="isUsernameFocus = true"
          @blur="isUsernameFocus = false"
        />
      </el-form-item>

      <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual>
        <el-form-item :class="isPasswordFocus ? 'el-form-item-focus' : ''" prop="password">
          <el-input
            v-model="loginForm.password"
            :key="passwordType"
            :type="passwordType"
            ref="password"
            placeholder="请输入密码"
            name="password"
            tabindex="2"
            autocomplete="on"
            @focus="isPasswordFocus = true"
            @blur="isPasswordFocus = capsTooltip = false"
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
      </el-tooltip>

      <el-button
        :loading="loading"
        type="primary"
        style="width:100%;margin-bottom:30px;"
        @click.native.prevent="handleLogin"
      >
        登录
      </el-button>

    </el-form>

    <el-dialog title="请选择门店进行登录" :visible.sync="showStores" custom-class="login-store-dialog">
      <el-table
        :data="stores"
        v-loading="isLogging"
        @row-click="loginWithStoreId"
        row-class-name="login-store-column"
      >
        <el-table-column property="store_name" label="门店"/>
        <el-table-column property="role_name" label="身份"/>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import RouteConfig from '@/router/config';
  import { encodeRedirect, parseRedirect } from '@/utils/redirect';

  const validateUsername = (rule, value, callback) => {
    if (value.length < 3) {
      callback(new Error('用户名不存在，请重新输入'));
    } else {
      callback();
    }
  };
  const validatePassword = (rule, value, callback) => {
    if (value.length < 8 || value.length > 16) {
      callback(new Error('密码错误，请重新输入'));
    } else {
      callback();
    }
  };

  export default {
    name: RouteConfig.login.name,
    data: () => ({
      redirectPath: RouteConfig.home.path,
      redirectQuery: {},
      isUsernameFocus: false,
      isPasswordFocus: false,
      we_chat_code: '',
      query: {},
      loginForm: {
        username: '',
        password: '',
        store_id: 0,
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      showStores: false,

      isLogging: false,
      stores: [],
      workAppId: 'ww61bafc9926522eb0',
      workScope: 'snsapi_base',
      serviceAppId: 'wx5689ab1e52acb2af',
      serviceScope: 'snsapi_userinfo',
      currentAppId: '',
      currentScope: '',
    }),
    mounted() {
      if (this.loginForm.username === '') {
        this.$refs.username.focus();
      } else if (this.loginForm.password === '') {
        this.$refs.password.focus();
      }

      const { query } = this.$route;
      if (!query) return;

      const redirectStr = query.redirect;
      const not_auto_login = query.is_not_auto_login;
      const we_chat_code = query.code || '';

      delete query.is_not_auto_login;
      delete query.code;
      delete query.redirect;

      if (redirectStr) {
        // 兼容 JSON 格式与历史遗留的裸路径字符串格式
        const redirect = parseRedirect(redirectStr);
        const redirectPath = redirect && redirect.path;
        if (redirectPath && redirectPath !== RouteConfig.login.path) {
          this.redirectPath = redirectPath;
          this.redirectQuery = redirect.query || {};
        }
      }

      let { userAgent } = navigator;
      userAgent = userAgent.toLowerCase();
      const isWork = userAgent.includes('wxwork');
      const isService = userAgent.includes('micromessenger');
      if (!isWork && !isService) return;
      if (not_auto_login) return;

      this.currentAppId = isWork ? this.workAppId : this.serviceAppId;
      this.currentScope = isWork ? this.workScope : this.serviceScope;
      this.we_chat_code = we_chat_code;
      we_chat_code ? this.login({ we_chat_code }) : this.getWeChatCode();
    },
    beforeCreate() {
      let vd = document.getElementById('login-css'), style = `
body {
    background-color: #161622;
}
#header {
    display: none;
}

#section {
    display: block;
    padding-bottom: 0;
}

#menu {
    display: none;
}

#footer {
    diplay: none;
}`;
      if (vd) {
        vd.innerHTML = style;
      } else {
        vd = document.createElement('style');
        vd.id = 'login-css';
        vd.innerHTML = style;
        document.head.appendChild(vd);
      }
    },
    beforeDestroy() {
      document.getElementById('login-css').innerHTML = '';
    },
    methods: {
      async loginWithStoreId({id}) {
        if (this.isLogging) return;

        const postData = { ...this.loginForm };
        postData.store_id = id;
        postData.we_chat_code = this.we_chat_code;
        this.isLogging = true;

        const { isError } = await this.$store.dispatch('user/loginWithStoreId', postData);

        this.isLogging = false;
        if (isError) return;

        this.$router.push({ path: this.redirectPath, query: this.redirectQuery });
      },
      async login(data, isPasswordLogin = false) {
        if (this.isLogging) return;

        this.isLogging = true;
        const { isError, stores } = await this.$store.dispatch('user/login', data);
        this.isLogging = false;
        if (isError) return;

        if (stores) {
          this.stores = stores;
          this.showStores = true;
          if (isPasswordLogin) this.we_chat_code = '';
          return;
        }

        this.$router.push({ path: this.redirectPath, query: this.redirectQuery });
      },
      handleLogin() {
        if (this.isLogging) return;

        this.$refs.loginForm.validate(async (isSuccess) => {
          if (isSuccess) this.login(this.loginForm, true);
        });
      },
      buildUri({ path, queryParams, hash }) {
        const data = [];
        Object.keys(queryParams).forEach((k) => {
          data.push(`${encodeURIComponent(k)}=${encodeURIComponent(queryParams[k])}`);
        });
        return `${path}${data.length ? '?' : ''}${data.join('&')}#${hash}`;
      },
      getWeChatCode() {
        // 回跳地址最小化：仅保留 pathname + redirect 参数，避免把 code / is_not_auto_login
        // 等杂项或超长 URL 带给微信回调，否则回调地址会被截断/污染导致 redirect 丢失。
        const redirectUri = `${location.origin}${location.pathname}?redirect=${encodeRedirect(this.redirectPath, this.redirectQuery)}`;
        location.href = this.buildUri({
          path: 'https://open.weixin.qq.com/connect/oauth2/authorize',
          queryParams: {
            appid: this.currentAppId,
            redirect_uri: redirectUri,
            response_type: 'code',
            scope: this.currentScope,
          },
          hash: 'wechat_redirect',
        });
      },
    },
  };
</script>

<style scoped>
  .login-container {
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background: url(https://img.jiahewushe.com/app/banner/mine-cover.jpg) no-repeat center center;
    background-size: cover;
  }

  .login-form {
    position: relative;
    width: 520px;
    padding: 42px;
    overflow: hidden;
    background: rgba(255, 255, 255, .3);
    backdrop-filter: blur(10px);
  }

  .el-input {
    display: inline-block;
    /*height: 47px;*/
    width: 85%;
  }

  .input {
    background: transparent;
    border: 0;
    -webkit-appearance: none;
    border-radius: 0;
    padding: 12px 5px 12px 6px;
    margin-left: 10px;
    height: 47px;
    font-size: 16px;
    color: #fff;
  }

  input:-webkit-autofill {
     box-shadow: 0 0 0 1000px rgb(255, 255, 255, .1) inset !important;
     -webkit-text-fill-color: #000 !important;
  }


  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 5px;
    color: #fff;
  }

  .el-form-item__error {
    color: #ffbc00;
  }

  .el-form-item:hover {
    border-color: #409EFF;
  }

  .el-form-item-focus {
    border-color: #409EFF;
  }



  .tips {
    font-size: 14px;
    margin-bottom: 10px;
  }

  span:first-of-type {
    margin-right: 16px;
  }

  .icon-box {
    display: inline-block;
    width: 30px;
    padding: 6px 5px 6px 15px;
    vertical-align: middle;
    color: #fff;
  }

  .title {
    padding: 20px 5px;
    font-size: 30px;
    font-weight: bold;
    color: #fff;
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    cursor: pointer;
    user-select: none;
  }

  .login-store-dialog {
    width: 500px;
  }

  .login-store-column {
    cursor: pointer;
  }
</style>
